<dx-popup 
  [width]="500" 
  [height]="250" 
  [showTitle]="true" 
  title="Actualizar Email" 
  [closeOnOutsideClick]="true" 
  [(visible)]="visible"
  (onHidden)="close()">
  
  <div *dxTemplate="let data of 'content'">
    <div class="">
      <div class="responsive-paddings">
        
        <!-- Nuevo Email -->
        <div class='dx-field'>
          <div class='dx-field-label'>Nuevo Email: </div>
          <div class='dx-field-value'>
            <dx-text-box [(value)]="newEmail"></dx-text-box>
          </div>
        </div>

        <!-- Submit -->
        <div class="float-right">
          <dx-button id="buttonCancel" type="" text="Cancelar" class="mr-3" (click)="close()"></dx-button>
          <dx-button id="button" [useSubmitBehavior]="true" type="default" text="Actualizar" (onClick)="updateEmail($event)"></dx-button>
        </div>
      </div>
    </div>
  </div>
</dx-popup>